<template>
  <div class="flex flex-col items-center justify-center gap-2">
    <h4 class="text-gray-500-dark">
      {{ title_survey }}
    </h4>
    <Rating
      v-if="question_type === SurveyQuestion.NPS || question_type === SurveyQuestion.OPINION_SCALE"
      :default_value="score"
      :disabled="disabled"
      :question_type="question_type"
      @scoreSelected="scoreSelected"
    />
    <YesNo
      v-if="question_type === SurveyQuestion.YES_NO"
      :default_value="score"
      :disabled="disabled"
      @scoreSelected="scoreSelected"
    />
    <Satisfaction
      v-if="question_type === SurveyQuestion.SATISFACTION"
      :default_value="score"
      :disabled="disabled"
      @scoreSelected="scoreSelected"
    />
    <FixedChoice
      v-if="question_type === SurveyQuestion.FIXED_CHOICE"
      :fixed_options="fixed_options"
      :disabled="disabled"
      @scoreSelected="scoreSelected"
    />
    <b-field
      :label="
        question_type !== SurveyQuestion.OPEN_ENDED ? $t('survey.labels.comments') : $t('survey.labels.answerRequired')
      "
      class="w-full"
    >
      <b-input
        v-model="feedback"
        data-test="survey-comments-input"
        :disabled="disabled"
        type="textarea"
        :required="question_type === SurveyQuestion.OPEN_ENDED"
      />
    </b-field>
  </div>
</template>

<script>
import Rating from '@/app/shared_components/surveys/Rating.vue';
import YesNo from '@/app/shared_components/surveys/YesNo.vue';
import Satisfaction from '@/app/shared_components/surveys/Satisfaction.vue';
import { SurveyQuestion } from '@/app/data/model_constants';
import { mapGetters } from 'vuex';
import FixedChoice from '@/app/shared_components/surveys/FixedChoice.vue';

export default {
  name: 'SurveyForm',
  components: { FixedChoice, Satisfaction, YesNo, Rating },
  props: {
    disabled: { type: Boolean, default: false },
    title: { type: String, default: null },
    question_type: { type: String, default: null },
    question_number: { type: Number, default: null },
    questions: { type: Number, default: null },
    fixed_options: { type: Array, default: null },
  },

  emits: ['feedback-updated', 'score-selected'],

  data() {
    return {
      score: null,
      feedback: null,
      SurveyQuestion,
    };
  },

  computed: {
    ...mapGetters(['current_client']),

    title_survey() {
      if (this.question_type === SurveyQuestion.NPS) {
        return this.$t('survey.labels.NPSQuestion', { name: this.current_client.attributes.name });
      }
      if (this.title) return this.title;
      return '...';
    },
  },

  watch: {
    title() {
      this.score = null;
      this.feedback = null;
    },

    feedback() {
      this.$emit('feedbackUpdated', this.feedback);
      if (this.question_type === this.SurveyQuestion.OPEN_ENDED) {
        this.scoreSelected(1);
      }
    },
  },

  methods: {
    scoreSelected(newScore) {
      this.$emit('scoreSelected', newScore);
      this.score = newScore;
    },
  },
};
</script>
